import type {ReactElement} from 'react';
import classNames from 'classnames';

interface Props {
    left?: boolean;
    right?: boolean;
}

export default function ArrowIcon(props: Props): ReactElement<Props> {
    const rootClass = classNames({
        'arrow-icon--left': props.left,
        'arrow-icon--right': props.right,
    });
    return <div className={rootClass} />;
}
